import { createRouter, createWebHistory } from 'vue-router'
import { Login as LoginScreen } from '@monolith/components'
import ChooseStore from '../components/Auth/ChooseStore.vue'
import ChooseStation from '../components/Auth/ChooseStation.vue'
import PasswordReset from '../components/Auth/PasswordReset.vue'
import TemperatureDashboard from '../components/Temperature/TemperatureDashboard.vue'
import TemperatureRecord from '../components/Temperature/TemperatureRecord.vue'
import TemperatureHistory from '../components/Temperature/TemperatureHistory.vue'

const routes = [
  {
    path: '/',
    name: 'LoginScreen',
    component: LoginScreen
  },
  {
    path: '/chooseStore',
    name: 'ChooseStore',
    component: ChooseStore
  },
  {
    path: '/chooseStation',
    name: 'ChooseStation',
    component: ChooseStation
  },
  {
    path: '/password',
    name: 'password',
    component: PasswordReset
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: TemperatureDashboard
  },
  {
    path: '/record',
    name: 'record',
    component: TemperatureRecord
  },
  {
    path: '/history',
    name: 'history',
    component: TemperatureHistory
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
